import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import EnquiryForm from '../EnquiryForm';
import StudentDetailsView from '../StudentDetailsView';
import AllCenterCourses from '../../AllCenterCourses';

const Sidebar = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const jwtToken = localStorage.getItem("jwt_token");
    if (!jwtToken) {
      navigate("/");
    }
  }, [navigate]);

  const logOut = () => {
    localStorage.removeItem("jwt_token");
    localStorage.removeItem("center");
    navigate("/");
  };

  const getNavClass = (target) =>
    `nav-link w-100 px-3 py-2 mb-2 d-flex align-items-center rounded ${
      id === target ? 'bg-primary text-white' : 'text-light'
    }`;

  return (
    <div className="container-fluid" style={{ height: "100vh" }}>
      <div className="row flex-nowrap">
        {/* Sidebar */}
        <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0 bg-dark d-flex flex-column justify-content-between" style={{ height: "100vh" }}>
          <div className="px-3 pt-3 text-white w-100">
            <div className="mb-4 text-center">
              <i className="bi bi-microsoft text-white fs-3 mb-2"></i>
              <h5 className="fw-bold m-0">Datapro</h5>
              <small className="text-muted">Computers</small>
            </div>
            <ul className="nav flex-column">
              <li className="nav-item">
                <a href="/navbar/enquiry-form" className={getNavClass('enquiry-form')}>
                  <i className="bi bi-person-plus-fill me-2"></i> Register Student
                </a>
              </li>
              <li className="nav-item">
                <a href="/navbar/student-details" className={getNavClass('student-details')}>
                  <i className="bi bi-file-earmark-text me-2"></i> View Students
                </a>
              </li>
              <li className="nav-item">
                <a href="/navbar/courses" className={getNavClass('courses')}>
                  <i className="bi bi-book-half me-2"></i> Courses
                </a>
              </li>
            </ul>
          </div>
          <div className="text-center pb-4">
            <button className="btn btn-outline-light btn-sm w-75" onClick={logOut}>
              <i className="bi bi-box-arrow-right me-1"></i> Logout
            </button>
          </div>
        </div>

        {/* Main content */}
        <div className="col py-3" style={{ height: "100vh", overflow: "auto" }}>
          {id === 'enquiry-form' && <EnquiryForm />}
          {id === 'student-details' && <StudentDetailsView />}
          {id === 'courses' && <AllCenterCourses />}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
